module.exports = __webpack_public_path__ + "static/media/room-service.b2ec43ef.png";